import { EntityDetailViewProps } from "../../common/entity/EntityInterfaces";
import { EntityDetailPage, EntityDetailView } from "../../common/entity/EntityDetailPage";
import { EntityTablePage } from "../../common/entity/EntityTablePage";
import { CustomTypeTemplatePackagesTable } from "./CustomTypeTempaltePackagesTable";
import { CustomTypeTemplatePackagesDetail } from "./CustomTypeTemplatePackagesDetail";

// Detail
export const CustomTypeTemplatePackagesDetailView = ({ id }: EntityDetailViewProps<"customTypeTemplatePackages">) => {
  return (
    <EntityDetailView id={id} entityTypeId={"customTypeTemplatePackages"} filters={{}}>
      {(props) => <CustomTypeTemplatePackagesDetail {...props} />}
    </EntityDetailView>
  );
};

export const CustomTypeTemplatePackageDetailsPage = () => {
  return (
    <EntityDetailPage<"customTypeTemplatePackages"> isIntId>
      {(id) => <CustomTypeTemplatePackagesDetailView id={id} />}
    </EntityDetailPage>
  );
};

export const CustomTypeTemplatePackagesTablePage = () => {
  return (
    <EntityTablePage entityTypeId={"customTypeTemplatePackages"}>
      {(props) => <CustomTypeTemplatePackagesTable {...props} />}
    </EntityTablePage>
  );
};
